import { createStyles, Fab, makeStyles, useScrollTrigger, Zoom } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            position: 'fixed',
            bottom: theme.spacing(2),
            right: theme.spacing(2),
            zIndex: theme.zIndex.tooltip + 100,
        },
    })
);

const AppScrollTo: React.FC = () => {
    const { pathname, search, hash } = useLocation();
    const classes = useStyles();

    const appScroll = (hash?: string) => {
        const valid_hash = hash !== undefined && /^#[\w\d-]+$/.test(hash);
        const target = valid_hash ? document.querySelector(hash!) : undefined;

        try {
            if (target) target.scrollIntoView({ behavior: 'smooth' });
            else
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
        } catch (error) {
            if (target) target.scrollIntoView();
            else window.scrollTo(0, 0);
        }
    };

    // Once component did mount
    useEffect(() => {
        // If ther is a hash link in the url for initial page load
        // we register a timeout to smooth scroll to the target
        if (window.location.hash !== '') {
            window.setTimeout(() => {
                appScroll(window.location.hash);
            }, 500);
        }
    }, []);

    // Whenever pathname, search, hash changes
    useEffect(() => {
        window.setTimeout(() => {
            appScroll(hash);
        }, 100);
    }, [pathname, search, hash]);

    // Scrolltrigger
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 100,
    });

    return (
        <Zoom in={trigger}>
            <Fab
                size="small"
                role="presentation"
                aria-label="scroll back to top"
                className={classes.root}
                onClick={() => appScroll()}>
                <KeyboardArrowUpIcon />
            </Fab>
        </Zoom>
    );
};

export default AppScrollTo;
